__<template>
  <div>
    <table class="text-grey-800 bg-white w-full shadow-lg">
      <thead class="text-sm border-b-2 border-grey-300">
        <tr>
          <th
            class="px-4 py-2 text-left w-64"
          >
            Assessment
          </th>
          <th class="px-4 py-2 w-32">
            Score
          </th>
          <th
            v-if="booster"
            class="px-4 py-2 w-32"
           >
            Booster
          </th>
          <th
            v-if="includesRecommendedField"
            class="px-4 py-2 w-12"
          >
            Recommended
          </th>
          <th class="px-4 py-2 w-48">
            {{ acceptLabel }}/{{ rejectLabel }}
          </th>
          <th class="px-4 py-2 w-12">
            Confirmed
          </th>
          <th class="px-4 py-2 w-10">
            Comments
          </th>
          <th class="px-4 py-2 w-12">
            Recipients
          </th>
          <th class="px-4 py-2 w-12">
            Preview
          </th>
          <th class="px-4 py-2 w-12">
            Notified
          </th>
        </tr>
      </thead>
      <transition-group
        name="flip-list"
        tag="tbody"
      >
        <funding-assessments-review-table-entry
          v-for="assessment in sortedAssessments"
          :key="assessment.uuid"
          :assessment="assessment"
          :booster="booster"
          :show-recommended="includesRecommendedField"
        />
      </transition-group>
      <tfoot>
        <tr class="border-t-2">
          <td
            :colspan="includesRecommendedField ? 3 : 2"
            class="stripes-grey"
          ></td>
          <td class="text-center font-bold text-xl px-4 py-2">
            {{ approvedCount }}/{{ rejectedCount }}
          </td>
          <td class="text-center font-bold text-xl px-4 py-2">
            {{ confirmedCount }}
          </td>
          <td class="text-center font-bold text-xl px-4 py-2">
            {{ notifiedCount }}
          </td>
          <td class="stripes-grey"></td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>
<script>

export default {
  name: "ReviewTable",
  props: {
    applications: {
      type: [Array],
      required: true
    },
    streams: {
      type: [Array],
      default: () => []
    },
  },
  data() {
    return {
      selectedStatus: "",
      loading: false,
      modalOpen: false,
      modalAssessment: null,
      assessments: [],
      selected: []
    };
  },
  computed: {
    booster() {
      return this.$page.marking_phase?.template?.booster ?? null;
    },
    acceptLabel() {
      return this.$page.marking_phase?.terminology?.accept ?? 'Approve'
    },
    rejectLabel() {
      return this.$page.marking_phase.terminology?.reject ?? 'Reject'
    },
    includesRecommendedField() {
      return this.$page.marking_phase?.template?.listing_fields.includes('recommended') ?? false
    },
    assessmentsByStream() {
      if(this.streams.length == 0) return this.assessments
      return this.assessments.filter(a => this.streams.includes(a.stream))
    },
    approvedAssessments() {
      return this.assessmentsByStream.filter(({pivot: ap}) => ap.approved_at && ap.confirmed_at).sort(this.recommendedAndPercentageSort)
    },
    rejectedAssessments() {
      return this.assessmentsByStream.filter(({pivot: ap}) => ap.rejected_at && ap.confirmed_at).sort(this.recommendedAndPercentageSort)
    },
    undecidedAssessments() {
      return this.assessmentsByStream.filter(({pivot: ap}) => !ap.confirmed_at).sort(this.recommendedAndPercentageSort)
    },
    sortedAssessments() {
      return [
        ...this.approvedAssessments,
        ...this.undecidedAssessments,
        ...this.rejectedAssessments
      ]
    },
    approvedCount() {
      return this.assessments.filter(assessment => assessment.pivot.status === 'approve').length
    },
    rejectedCount() {
      return this.assessments.filter(assessment => assessment.pivot.status === 'reject').length
    },
    confirmedCount() {
      return this.assessments.filter(assessment => assessment.pivot.confirmed_at).length
    },
    notifiedCount() {
      return this.assessments.filter(assessment => assessment.pivot.notified_at).length
    }
  },
  created() {
    this.assessments = this.applications.map(this.assignScore)
  },
  methods: {
    assignScore(assessment) {
      const allAssessorGrades = assessment.all_assessor_grades_current_phase
      const allAssessorGradesCount = allAssessorGrades.length
      const additionalKeys = {
        totalScore: 0,
        totalPercentage: 0,
        recommendedTotal: 0,
      }

      for (let index = 0; index < allAssessorGradesCount; index++) {
        const currentAssessor = allAssessorGrades[index];
        additionalKeys.totalScore += currentAssessor.total
        additionalKeys.totalPercentage += currentAssessor.percentage
        if(currentAssessor.recommended) additionalKeys.recommendedTotal++;
      }

      additionalKeys.totalPercentage = parseFloat((additionalKeys.totalPercentage / assessment.assessors.length).toFixed(2))

      return {
        ...assessment,
        ...additionalKeys
      }
    },

    recommendedAndPercentageSort(a, b) {

      const compareTotalAssessors = a.assessors.length + b.assessors.length
      const compareRecommendedTotal = a.recommendedTotal + b.recommendedTotal

      if(this.includesRecommendedField) {
        if(compareRecommendedTotal < compareTotalAssessors - 2) {
          if(a.recommendedTotal < b.recommendedTotal) return 1
          if(a.recommendedTotal > b.recommendedTotal) return -1
        }
      }

      if(a.totalPercentage < b.totalPercentage) return 1
      if(a.totalPercentage > b.totalPercentage) return -1

      return 0

    },
  }
};
</script>
